import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoutesUtil } from '../utils/routes.util';
import { UserNotification, UserNotificationsQuery } from '../actions/user-notifications.actions';

export interface UserNotificationsResponse {
    notifications: UserNotification[];
    unreadCount: number;
}

@Injectable({
    providedIn: 'root',
})
export class UserNotificationsService {
    constructor(private readonly http: HttpClient, private readonly routesUtil: RoutesUtil) {}

    public getUserNotifications$(request: UserNotificationsQuery): Observable<UserNotificationsResponse> {
        const url = this.routesUtil.buildUserNotificationsUrl();

        let params = new HttpParams()
            .set('offset', String(request.offset))
            .set('limit', String(request.limit))
            .set('archived', String(request.filter.archived));

        if (request.filter.read !== undefined) {
            params = params.set('read', String(request.filter.read));
        }

        return this.http.get<UserNotificationsResponse>(url, { params });
    }

    public updateNotifications$(
        notificationIds: string[],
        update: { isRead?: boolean; isArchived?: boolean },
    ): Observable<UserNotificationsResponse> {
        const url = `${this.routesUtil.buildUserNotificationsUrl()}/bulk-update`;
        return this.http.post<UserNotificationsResponse>(url, { notificationIds, ...update });
    }
}
